import { FC } from 'react';
import { Section } from '../../../../components';
import {
	Form,
	FullLineLooker,
	Separator,
	TitleContainer
} from '../../Reports.styles';


const AdminLookerPagamentos: FC = () => {
	return (
		<>
			<Section>
				<TitleContainer>Pagamentos</TitleContainer>
				<Separator />
				<Form>
					<FullLineLooker>
						<iframe
							title="Relatório de Pagamentos"
							width="100%"
							height="100%"
							src="https://lookerstudio.google.com/embed/reporting/53c0cf4e-1c52-4b02-be83-cb7d6addb32e/page/iuU6D"
							frameBorder="0"
							style={{ border: 0 }}
							allowFullScreen
							sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
						></iframe>
					</FullLineLooker>
				</Form>
			</Section>
		</>
	);
};

export default AdminLookerPagamentos;
